import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import { isMobile } from '@/utils/common.js'
import toastObject from '@/utils/toast.js'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$isMobile = isMobile
Vue.prototype.$toast = toastObject


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
